'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactReSuperTabs = require('react-re-super-tabs');





var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _TabSellingProperties = require('../TabSellingProperties/TabSellingProperties');var _TabSellingProperties2 = _interopRequireDefault(_TabSellingProperties);
var _TabPrivateBrokerage = require('../TabPrivateBrokerage/TabPrivateBrokerage');var _TabPrivateBrokerage2 = _interopRequireDefault(_TabPrivateBrokerage);
var _TabEstateBoard = require('../TabEstateBoard/TabEstateBoard');var _TabEstateBoard2 = _interopRequireDefault(_TabEstateBoard);
var _TabVirtualTour = require('../TabVirtualTour/TabVirtualTour');var _TabVirtualTour2 = _interopRequireDefault(_TabVirtualTour);

var _NavTabs = require('./NavTabs.scss');var styles = _interopRequireWildcard(_NavTabs);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var styleTab = {
  padding: '10px 10px',
  display: 'inline-flex',
  cursor: 'pointer',
  width: '20vw',
  color: '#231F20',
  textAlign: 'center',
  fontSize: '24px',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Assistant' };


var styleActiveTab = Object.assign({},
styleTab, {
  color: '#FFFFFF',
  background: '#04AAEB 0% 0% no-repeat padding-box',
  border: 'solid #04AAEB 1px',
  margin: '2px 0 0',
  borderRadius: '31px 31px 0px 0px' });


var tabId = {
  exposure: 'internationalExposure',
  allAds: 'allAdsTogether',
  advertisements: 'noAdvertisements',
  virtual: 'virtualTour' };var


NavTabs = function (_Component) {_inherits(NavTabs, _Component);function NavTabs() {var _temp, _this, _ret;_classCallCheck(this, NavTabs);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    handleClick = function (event) {
      var hiddenElement = event.currentTarget;
      hiddenElement.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'center' });
    }, _this.

    customTab = function (event) {return (
        _react2.default.createElement('span', {
            onClick: _this.handleClick,
            style: event.isActive ? styleActiveTab : styleTab,
            className: styles.tab },

          event.children));}, _temp), _possibleConstructorReturn(_this, _ret);}NavTabs.prototype.



  render = function render() {
    var translate = this.props.translate('NavTabs');

    return (
      _react2.default.createElement('div', { className: styles.tabsWrapper },
        _react2.default.createElement(_reactReSuperTabs.Tabs, { activeTab: tabId.exposure },
          _react2.default.createElement(_reactReSuperTabs.TabList, { id: 'tabList', className: styles.tabs },
            _react2.default.createElement(_reactReSuperTabs.Tab, {
              component: this.customTab,
              label: translate(tabId.exposure, 'label'),
              id: tabId.exposure }),

            _react2.default.createElement(_reactReSuperTabs.Tab, {
              component: this.customTab,
              label: translate(tabId.allAds, 'label'),
              id: tabId.allAds }),

            _react2.default.createElement(_reactReSuperTabs.Tab, {
              component: this.customTab,
              label: translate(tabId.advertisements, 'label'),
              id: tabId.advertisements }),

            _react2.default.createElement(_reactReSuperTabs.Tab, {
              component: this.customTab,
              label: translate(tabId.virtual, 'label'),
              id: tabId.virtual })),


          _react2.default.createElement(_reactReSuperTabs.TabList, null,
            _react2.default.createElement(_reactReSuperTabs.TabPanel, { component: _TabSellingProperties2.default, id: tabId.exposure }),
            _react2.default.createElement(_reactReSuperTabs.TabPanel, { component: _TabEstateBoard2.default, id: tabId.allAds }),
            _react2.default.createElement(_reactReSuperTabs.TabPanel, { component: _TabPrivateBrokerage2.default, id: tabId.advertisements }),
            _react2.default.createElement(_reactReSuperTabs.TabPanel, { component: _TabVirtualTour2.default, id: tabId.virtual })))));




  };return NavTabs;}(_react.Component);


NavTabs.propTypes = {
  translate: _propTypes2.default.func };exports.default =



NavTabs;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/StatefulTabs/NavTabs.js
// module id = 2892
// module chunks = 0